import {combineLatest, merge} from 'rxjs';
import {distinctUntilChanged, filter, map, shareReplay, startWith, tap} from 'rxjs/operators';
import {track} from '@/et';
import {ContractAccountMarginMode, RiskMode} from '@/enum/index';
import {ptConfig$} from '@/config';
import {aopMsgV2$} from '@/raw/aop';
import {usdtRiskModeRas$} from '@/ras/ras';
import {contractAccountsCache$} from './contract-accounts-cache';
import type {CurrencyEntity, ws} from '@/types';

// PT手续费折扣活动
// 仅支持USDT合约
// 初始状态为 false，若 ws 有 account_p1 PT account 数据推送，则以推送的 status 为准
// status： 0:默认状态|1:开启|2:关闭
export const contractPTDiscountState$ = combineLatest([aopMsgV2$, ptConfig$]).pipe(
  filter(([data]) => !!data.accounts),
  map(([data, ptConfig]: [{accounts: ws.ContractAccountRawV2[]}, CurrencyEntity]) =>
    data.accounts.find((o) => o.currency === ptConfig.symbol)
  ),
  filter(Boolean),
  tap((account) => {
    track('aop_pt_account', {content: account});
  }),
  map((o) => o.status === 1),
  distinctUntilChanged(),
  startWith(false),
  shareReplay(1)
);

contractPTDiscountState$.subscribe();

const usdtRiskModeAop$ = contractAccountsCache$.pipe(
  map((o) => (o.has('USDT') ? RiskMode[o.get('USDT').userMode] : null)),
  filter(Boolean)
);

export const contractMarginMode$ = merge(usdtRiskModeRas$, usdtRiskModeAop$).pipe(
  map((mode) => (mode === RiskMode.MultiAsset ? ContractAccountMarginMode.Multi : ContractAccountMarginMode.Single)),
  startWith(ContractAccountMarginMode.Single),
  shareReplay(1)
);
